module.exports = __webpack_public_path__ + "static/media/error.d5da25ce.png";